var PageBackgroundSupport    = require("app/ui/PageBackgroundSupport"),
    PaymentTableRow          = require("./PaymentTableRow"),
    PopupLayout              = require("app/AppLayout/PopupLayout"),
    RepeaterArrayDataAdapter = require("enyo-ui/RepeaterArrayDataAdapter"),
    ScrollerPopup            = require("app/ui/ScrollerPopup"),
    SimpleRepeater           = require("enyo-ui/SimpleRepeater"),
    ImageOptimizerSupport    = require("app/ui/ImageOptimizerSupport"),
    closeButtonThemeVars     = require("app/theme/IconButtonVariables--close"),
    frameThrottle            = require("enyo-perf/utils").frameThrottle,
    get                      = require("object-path").get,
    kind                     = require("enyo/kind"),
    themeVars                = require("app/theme/variables.js");

require("./PaymentsPopup.less");
require("app/theme/styles/popups/ScrollerPopup--bordered.less");

module.exports = kind(/** @lends app.ProfilePage.PaymentsPopup */ {

    /**
     * @private
     */
    name: "app.ProfilePage.PaymentsPopup",

    /**
     * @private
     */
    kind: ScrollerPopup,

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    layoutKind: PopupLayout,

    /**
     * @private
     */
    layoutOptions: {
        alignment:       "fullLayout",
        expand:          false,
        overlapSafeArea: false,

        /**
         * @returns {number} The margin in pixels
         */
        marginTop: function() {
            return themeVars.getContentPaddingVerticalPx()
                + (this.container.get("showCloseButton")
                    ? closeButtonThemeVars.getIconSize() / 2
                    : 0);
        },

        /**
         * @returns {number} The margin in pixels
         */
        marginBottom: function() {
            return themeVars.getContentPaddingVerticalPx();
        }
    },

    /**
     * @private
     */
    classes: "app-profile-page-payments-popup",

    /**
     * @public
     */
    theme: "bordered",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        tag:        "table",
        classes:    "app-profile-page-payments-popup__table",
        components: [{
            tag:        "thead",
            classes:    "app-profile-page-payments-popup__thead",
            components: [{
                tag:        "tr",
                classes:    "app-profile-page-payments-popup__tr",
                components: [{
                    name:    "paymentDateHeader",
                    tag:     "th",
                    content: "Date"
                }, {
                    name:    "paymentTypeHeader",
                    tag:     "th",
                    content: "Type"
                }, {
                    name:    "paymentAmountHeader",
                    tag:     "th",
                    content: "Amount"
                }, {
                    name:    "paymentStatusHeader",
                    tag:     "th",
                    content: "Status"
                }, {
                    name:    "paymentInvoiceHeader",
                    tag:     "th",
                    content: "Invoice"
                }]
            }]
        }, {
            name:            "payments",
            kind:            SimpleRepeater,
            classes:         "app-profile-page-payments-popup__tbody",
            tag:             "tbody",
            dataAdapterKind: RepeaterArrayDataAdapter,
            childKind:       PaymentTableRow
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            state       = this.state || {};

        this.$.paymentDateHeader.set("content", i18nService.getString("app.ProfilePage.PaymentsPopup.paymentDateHeader"));
        this.$.paymentTypeHeader.set("content", i18nService.getString("app.ProfilePage.PaymentsPopup.paymentTypeHeader"));
        this.$.paymentAmountHeader.set("content", i18nService.getString("app.ProfilePage.PaymentsPopup.paymentAmountHeader"));
        this.$.paymentStatusHeader.set("content", i18nService.getString("app.ProfilePage.PaymentsPopup.paymentStatusHeader"));
        this.$.paymentInvoiceHeader.set("content", i18nService.getString("app.ProfilePage.PaymentsPopup.paymentInvoiceHeader"));
        this.$.payments.set("data", get(state, "data.payments", []));
    }

});
